import { useEffect, useRef } from 'react';

type Props = {
  checked: boolean;
  indeterminate: boolean;
  disabled?: boolean;
  onChange: () => void;
  className?: string;
  'aria-label'?: string;
};

/**
 * indeterminate（中間）状態を扱えるチェックボックス。
 * Reactのpropsには indeterminate が無いため ref 経由でDOMに設定する。
 */
export const IndeterminateCheckbox: React.FC<Props> = ({
  checked,
  indeterminate,
  disabled,
  onChange,
  className,
  'aria-label': ariaLabel,
}: Props) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate && !checked;
    }
  }, [indeterminate, checked]);

  return (
    <input
      ref={ref}
      type="checkbox"
      className={className}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      aria-label={ariaLabel}
    />
  );
};
